import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'nodes-search',
  templateUrl: './nodes-search.component.html',
  styleUrls: ['./nodes-search.component.scss']
})
export class NodesSearchComponent implements OnInit {

  onApply = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<NodesSearchComponent>, @Inject(MAT_DIALOG_DATA) public search: any) {
  }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close();
    this.onApply.emit(this.search);
  }
}
